import { Service } from '@genial/services';
import { selectorFamily } from 'recoil';

import { addAuthorizationHeader } from '../../pages/BatchTicketInvestLink/Constants';
import { FixedFeeTermAcceptanceData } from '../../pages/FixedFeeTermAcceptanceLink/utils/types';

import { screenName } from './constants';
import { normalizeFixedFeePublicTerm } from './normalize';

export const fixedFeePublicTermQuery = selectorFamily<
  { data: FixedFeeTermAcceptanceData } | null,
  { termId: string; jwtToken?: string }
>({
  key: 'fixedFeePublicTermQuery',
  get:
    ({ termId, jwtToken }) =>
    async () => {
      if (!termId) {
        return null;
      }

      const data = await Service.FixedFee.V1.getAgreementByFeeBasedContract(
        {
          screenName,
          fixedFeeAgreementId: termId,
        },
        addAuthorizationHeader(jwtToken)
      );

      return { data: normalizeFixedFeePublicTerm(data) };
    },
});
